<template>
    <section class="banner-section">
        <div class="swiper swiper-banners">
            <div class="swiper-wrapper">
                <div
                    v-for="banner in banners"
                    :key="banner.banner_id"
                    class="swiper-slide"
                >
                    <div class="banner-section__item">
                        <a target="_blank" :href="banner.link"
                            ><img :src="banner.desktop_image.url" alt=""
                        /></a>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="swiper-button swiper-button-next swiper-button-banners-next"
        ></div>
        <div
            class="swiper-button swiper-button-prev swiper-button-banners-prev"
        ></div>
    </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: 'Banners',

    data() {
        return {
            swiperSlider: null
        }
    },

    computed: {
        ...mapState('banners', ['banners'])
    },
    mounted() {
        this.get().then(() => {
            this.$nextTick(() => {
                this.swiperSlider = new Swiper('.swiper-banners', {
                    slidesPerView: 'auto',
                    autoplay: {
                        delay: 5000
                    },
                    navigation: {
                        nextEl: '.swiper-button-banners-next',
                        prevEl: '.swiper-button-banners-prev',
                        disabledClass: 'hide'
                    }
                })
            })
        })
    },
    methods: {
        ...mapActions('banners', ['get'])
    }
}
</script>

<style scoped>
.swiper-button {
    width: 48px;
    height: 48px;
    filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.16));
    background-color: #fff;
    position: absolute;
    border-radius: 50%;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 100;
    background-image: url(/img/arrow_forward.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    cursor: pointer;
}
.swiper-button-next {
    right: -32px;
}
.swiper-button-prev {
    left: -32px;
}
</style>
